<template>
  <fin-risk-warnings-text :is-dialog="isDialog">
    <template #append>
      <h2>Weitere Risiken:</h2>
      <p>Zu weiteren Risiken in Verbindung mit Wertpapieranlagen:
        <fin-lexicon-text auto-solve style="display: inline-block" text="Risiko"/>
      </p>
    </template>
  </fin-risk-warnings-text>
</template>

<script>
import FinRiskWarningsText from "@/components/common/FinRiskWarningsText"
import FinLexiconText from "@/components/common/lexicon/LexiconText"

export default {
  components: {FinLexiconText, FinRiskWarningsText},
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  }
}
</script>

